import React from 'react';

/**
 * The central frosted surface. Ported from
 * D:\campaigning-system\src\components\ui\GlassCard.tsx (types stripped).
 * Every panel in the Campaigning Tool is a GlassCard so depth, translucency, and
 * shadow read consistently over the warm ivory canvas. Requires an ancestor with
 * the `.campaign-os` class (glass styles are scoped there — see campaign-os.css).
 */
export function GlassCard({
  children,
  interactive = false,
  accentRail = false,
  padded = true,
  className = '',
  ...rest
}) {
  return (
    <div
      className={[
        'glass-card',
        interactive ? 'glass-interactive cursor-pointer' : '',
        accentRail ? 'accent-rail' : '',
        padded ? 'p-5' : '',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
      {...rest}
    >
      {children}
    </div>
  );
}

export function CardHeader({ title, subtitle, icon, action, className = '' }) {
  return (
    <div className={`mb-4 flex items-start justify-between gap-3 ${className}`}>
      <div className="flex items-start gap-2.5">
        {icon}
        <div>
          <h3 className="text-[15px] font-bold leading-tight tracking-tight text-cos-ink">{title}</h3>
          {subtitle && <p className="mt-0.5 text-[12.5px] leading-tight text-cos-ink-secondary">{subtitle}</p>}
        </div>
      </div>
      {action}
    </div>
  );
}

export default GlassCard;
